import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IoMdCloseCircle } from 'react-icons/io';

const LanguageSelector = ({ isOpen, onClose }) => {
    const { i18n, t } = useTranslation();
    const [search, setSearch] = useState('');
    const languages = [
        { code: 'en', name: 'English' },
        { code: 'ar', name: 'العربية' },
    ];

    const filteredLanguages = languages.filter((lang) =>
        lang.name.toLowerCase().includes(search.toLowerCase())
    );

    const changelanguage = (language) => {
        i18n.changeLanguage(language);
        document.documentElement.dir = language === 'ar' ? 'rtl' : 'ltr';
        onClose(); // Close the modal
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div className="bg-white text-black w-[90%] max-w-md rounded-lg shadow-lg p-6 relative">

                <button
                    className="absolute text-black text-3xl  rounded-full hover:text-orange-700 right-2 top-2"
                    onClick={onClose}
                >
                    <IoMdCloseCircle />
                </button>
                <h2 className="text-lg font-bold mb-4">{t('selectLanguage')}</h2>

                <div className="relative w-full">
                    <input
                        type="text"
                        placeholder={t('searchPlaceholder')}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-full 
            focus:ring-blue-500 focus:border-blue-500 block w-full ps-10 p-2.5 
            dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 
            dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    />
                    <div className="absolute inset-y-0 end-0 flex items-center pe-3">
                        <svg
                            className="w-4 h-4 text-gray-500 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 20 20"
                        >
                            <path
                                stroke="currentColor"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                            />
                        </svg>

                    </div>
                </div>
                <ul className="max-h-60 overflow-y-auto">
                    {filteredLanguages.map((lang) => (
                        <li
                            key={lang.code}
                            className="p-2 hover:bg-gray-100 cursor-pointer"
                            onClick={() => changelanguage(lang.code)}
                        >
                            {lang.name}
                        </li>
                    ))}
                </ul>

            </div>
        </div>
    );
};

export default LanguageSelector;
